var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPageDark(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 31,
    height: 28,
    viewBox: "0 0 21 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.0002 27.3327H3.66683C1.82568 27.3327 0.333496 25.8379 0.333496 23.9993V3.99935C0.333496 2.1582 1.82568 0.666016 3.66683 0.666016H13.12C14.0054 0.666016 14.8491 1.01721 15.4741 1.64258L19.3595 5.52331C19.9845 6.15039 20.3335 6.99414 20.3335 7.87956V23.9993C20.3335 25.8379 18.8387 27.3327 17.0002 27.3327ZM3.66683 25.666H17.0002C17.922 25.666 18.6668 24.9212 18.6668 23.9993V7.87956C18.6668 7.43685 18.4897 7.01497 18.1772 6.70247L14.297 2.8207C13.9845 2.5082 13.5158 2.33268 13.12 2.33268H3.66683C2.74652 2.33268 2.00016 3.07904 2.00016 3.99935V23.9993C2.00016 24.9212 2.74652 25.666 3.66683 25.666Z",
    fill: "#000"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPageDark);
export default __webpack_public_path__ + "static/media/page-dark.5715f3ee189e971b1e19e6af29a241f0.svg";
export { ForwardRef as ReactComponent };